import dateTimeHelper from './datetimeHelper';
import mathHelper from './mathHelper';

export default class textHelper {
  static getDeactivationEmailBody(id)
  {
    return `Dear Recipients!

We have concluded our investigation into the shopper account with the shopper ID ${id}, and the findings have confirmed fraudulent activity. Please deactivate the account immediately to safeguard our platform's integrity and security.

If you need further information, please reach out to the Fraud Team directly.

Thank you for your prompt action.

Sincerely,
Fraud Team`;
  }

  static getDeactivationEmailSubject(id)
  {
    if(id)
    {
      return `Shopper Account Deactivation Request - ${id} - ${dateTimeHelper.nowStr()}`;
    }
    return `Shopper Account Deactivation Request - ${dateTimeHelper.nowStr()}`;
  }
}


